import React, { ReactNode } from 'react'

interface ErrorBoundaryProps {
	fallback?: ReactNode
	children?: ReactNode
}
interface ErrorBoundaryState {
	hasError: boolean
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError(_: unknown) {
		return { hasError: true }
	}

	render() {
		if (this.state.hasError) {
			return this.props.fallback ?? null
		}
		return this.props.children as ReactNode
	}
}
export default ErrorBoundary
